
import { useState } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { updateFlight } from '@/services/flightService';
import { FlightStatus } from '@/types/flight';

export function useFlightUpdate() {
  const [updating, setUpdating] = useState(false);
  const { toast } = useToast();

  const updateFlightData = async (
    flightId: string,
    data: {
      status: FlightStatus;
      scheduled_departure?: string;
      scheduled_arrival?: string;
      status_reason?: string;
    }
  ) => {
    setUpdating(true);
    try {
      const updateData: any = {
        status: data.status,
      };

      if (data.scheduled_departure) {
        updateData.scheduled_departure = new Date(data.scheduled_departure);
      }
      
      if (data.scheduled_arrival) {
        updateData.scheduled_arrival = new Date(data.scheduled_arrival);
      }
      
      if (data.status_reason !== undefined) {
        updateData.status_reason = data.status_reason;
      }

      await updateFlight(flightId, updateData);

      toast({
        title: "Flight updated",
        description: "Flight information has been updated successfully.",
      });

      return true;
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Update failed",
        description: error.message || "Failed to update flight.",
      });
      return false;
    } finally {
      setUpdating(false);
    }
  };

  return {
    updating,
    updateFlightData,
  };
}
